"use strict";const t="$$material";exports.THEME_ID=t;
